import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { sortTableRows } from "./utils/tableSort";
import { config, encodeBase64RequestBody } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const User = () => {
  const [users, setUsers] = useState(null);
  const [tableSearch, setTableSearch] = useState('');
  const [tableSortBy, setTableSortBy] = useState('full_name');
  const [tableSortType, setTableSortType] = useState('ascending');
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const searchInputRef = useRef(null);

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      const requestUsers = {};
      const fetchUsers = await jwtFetch(config.ENDPOINT + 'get/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUsers)
      });
      const responseUsers = await fetchUsers.json();
      if (responseUsers.status === 200) {
        for (let i in responseUsers.data) {
          let searchData = String(responseUsers.data[i].full_name ?? '').toLowerCase() + " ";
          searchData += String(responseUsers.data[i].user_position ?? '').toLowerCase() + " ";
          searchData += String(responseUsers.data[i].user_department ?? '').toLowerCase() + " ";
          searchData += String(responseUsers.data[i].user_role_division ?? '').toLowerCase() + " ";
          searchData += String(responseUsers.data[i].user_level ?? '').toLowerCase() + " ";
          responseUsers.data[i].search = searchData;
        }
        setUsers(responseUsers.data);
        setIsLoadingPage(false);
      } else {
        alert(responseUsers.message);
      }
    } catch (error) {
      console.error('Error in getUsers:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const sortTable = (sortBy) => {
    if (tableSortBy === sortBy) {
      setTableSortType(tableSortType === 'ascending' ? 'descending' : 'ascending');
    } else {
      setTableSortBy(sortBy);
      setTableSortType('ascending');
    }
  }

  const clearSearch = () => {
    setTableSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }

  return (
    <div id="user-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="user" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">User List</div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="input-group input-search">
                        <button className="btn bg-white" type="button" onClick={() => clearSearch()}>{tableSearch ? <i className="bi bi-x-lg" /> : <i className="bi bi-search" />}</button>
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value)} ref={searchInputRef} autoFocus />
                      </div>
                      {crmUser.user_level !== 'View' && (
                        <button className="btn btn-link bg-gold" type="button" onClick={() => window.location.href = '/user/add'}><i className="bi bi-plus-circle me-1" /> Add</button>
                      )}
                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    {users && users.length ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-gold">#</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('full_name')}>Name {tableSortBy === 'full_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('user_department')}>Department {tableSortBy === 'user_department' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('user_role_division')}>Role {tableSortBy === 'user_role_division' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('user_position')}>Position {tableSortBy === 'user_position' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer" onClick={() => sortTable('user_level')}>Type {tableSortBy === 'user_level' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('user_active')}>Status {tableSortBy === 'user_active' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortTableRows(users, tableSortBy, tableSortType === 'ascending')
                              .filter(user => (user.search || '').includes((tableSearch || '').trim().toLowerCase()))
                              .map((user, u) =>
                                <tr key={"user-" + u}>
                                  <td valign="middle">{u + 1}</td>
                                  <td valign="middle">{user.full_name}</td>
                                  <td valign="middle">{user.user_department}</td>
                                  <td valign="middle">{user.user_role_division}</td>
                                  <td valign="middle">{user.user_position}</td>
                                  <td valign="middle" align="center">{user.user_level}</td>
                                  <td valign="middle" align="center"><span className={"badge bg-" + (user.user_active === 'Active' ? 'success' : 'danger')}>{user.user_active}</span></td>
                                  <td valign="middle" align="right"><button className="btn btn-sm bg-gold" onClick={() => window.location.href = '/user/detail/' + user.user_keyid}><i className="bi bi-eye" /></button></td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>{isLoadingPage ? 'Loading...' : 'No data'}</p>
                    )}
                  </div>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;

